module.exports = __webpack_public_path__ + "static/media/burrito.76cb9566.svg";